import { render, staticRenderFns } from "./LeagueTable.vue?vue&type=template&id=dc979972&scoped=true&"
import script from "./LeagueTable.vue?vue&type=script&lang=js&"
export * from "./LeagueTable.vue?vue&type=script&lang=js&"
import style0 from "./LeagueTable.vue?vue&type=style&index=0&id=dc979972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc979972",
  null
  
)

export default component.exports